var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconArrows(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 0C20.8938 0 20 0.89375 20 2C20 3.10625 20.8938 4 22 4H25.1688L18.5875 10.5875C17.8063 11.3687 17.8063 12.6375 18.5875 13.4187C19.3688 14.2 20.6375 14.2 21.4188 13.4187L28 6.83125V10C28 11.1062 28.8938 12 30 12C31.1063 12 32 11.1062 32 10V2C32 0.89375 31.1063 0 30 0H22ZM13.4125 18.5875C12.6313 17.8062 11.3625 17.8062 10.5813 18.5875L4 25.1688V22C4 20.8937 3.10625 20 2 20C0.893754 20 3.8147e-06 20.8937 3.8147e-06 22V30C3.8147e-06 31.1063 0.893754 32 2 32H10C11.1063 32 12 31.1063 12 30C12 28.8937 11.1063 28 10 28H6.83125L13.4125 21.4125C14.1938 20.6313 14.1938 19.3625 13.4125 18.5812V18.5875Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrows);
export default __webpack_public_path__ + "static/media/icon-arrows.0580c02a78dbc8271144f1245c7eac5d.svg";
export { ForwardRef as ReactComponent };